/**
 * W3wIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const W3wIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8.509 7.433a.9.9 0 0 1 1.67.664l-2.797 8.262-.034.086a.9.9 0 0 1-1.696-.574l.025-.088L8.475 7.52zm4.078 0a.9.9 0 0 1 1.67.664l-2.797 8.262-.034.086a.9.9 0 0 1-1.696-.574l.025-.088 2.798-8.263zm4 0a.9.9 0 0 1 1.67.664l-2.797 8.262-.034.086a.9.9 0 0 1-1.696-.574l.025-.088 2.798-8.263z" />
    <path
      fillRule="evenodd"
      d="M21.184 1.209A1.8 1.8 0 0 1 22.8 3v18a1.8 1.8 0 0 1-1.8 1.8H3A1.8 1.8 0 0 1 1.2 21V3l.009-.184A1.8 1.8 0 0 1 3 1.2h18zM3 21h18V3H3z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const W3wIcon = makeIcon('W3wIcon', W3wIconSvg)
